import React from "react";

import LexwareIcon from "../icons/lexware.svg";

const lexofficePatterns = ["lexware", "lexoffice"];

export const AccountingSystem = ({
  targetSystem,
}: {
  targetSystem: string;
}) => {
  const matchesLexware = lexofficePatterns.some((pattern) =>
    targetSystem.toLowerCase().includes(pattern)
  );

  if (matchesLexware) {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <img
          src={LexwareIcon}
          alt="Lexware Office"
          style={{
            width: "40px",
            height: "40px",
            borderRadius: "50px",
          }}
        />
        <span>Lexware Office</span>
      </div>
    );
  }
  return <p>{targetSystem}</p>;
};
